import { render, staticRenderFns } from "./PlantOperatorCard.vue?vue&type=template&id=36977a5a&scoped=true&"
import script from "./PlantOperatorCard.vue?vue&type=script&lang=ts&"
export * from "./PlantOperatorCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36977a5a",
  null
  
)

export default component.exports